import React from "react";
const Loading = ({ size, extra }) => {
  return (
    <div className={`la-ball-clip-rotate ${size}${extra}`}>
      <div></div>
    </div>
  );
};

export default Loading;
